/* eslint-disable */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FunctionComponent } from 'react';
import { RequestTableView } from './requestTableView';


export const JsiInterceptorCookieView: FunctionComponent<{ cookies?: string[] }> = ({ cookies }) => {
    if (!cookies) return <></>;

    const requestCookieItems: string[][] = cookies
        .map((item: string) => item.trim())
        .filter((item: string) => item)
        .map((item: string) => item.split('='));
    return <RequestTableView data={requestCookieItems} headers={['name', 'value']} />;
};
